/**
 * Created by hernanherreros on 2019-05-30
 */

import * as React from 'react'
import { Row as AntRow } from 'antd'
import styled from 'styled-components'
import { space, SpaceProps } from 'styled-system'

interface Props {
  type?: string;
  justify?: string;
  align?: string;
}

const Row = styled(AntRow)<SpaceProps & Props>`
  ${space}
`

Row.defaultProps = {
  type: 'flex',
  justify: 'space-around',
  align: 'middle',
}

export default Row
